module.exports = __webpack_public_path__ + "static/media/Air-pollution-low.52f3f5c0.svg";